import { ReactComponent as Chevron } from '../../../../components/ReusableComponents/Messaging/ConversationRowTitle/chevron.svg'
import styles from './GroupedRow.module.scss'

const GroupedRow = ({ groupName, count, isExpanded, onToggle, children }) => {
  return (
    <>
      <div className={styles.groupHeader} onClick={onToggle}>
        <div className={styles.groupHeaderContent}>
          <div className={styles.groupName}>{groupName || 'Ungrouped'}</div>
          <div className={styles.groupCount}>{count} {count === 1 ? 'hotel' : 'hotels'}</div>
          <div className={`${styles.chevron} ${isExpanded ? styles.chevronUp : styles.chevronDown}`}>
            <Chevron />
          </div>
        </div>
      </div>
      {isExpanded && children}
    </>
  )
}

export default GroupedRow
